
import React, { useContext, useState } from 'react';
import { Header, Main } from '../NecttosComp/Layout/Layout';
import Button from '../NecttosComp/Button/Button';
import LMSDashboard from './components/Dashboard/LMSDashboard';
import CourseView from './components/Course/CourseView';
import ViewAssignmentSection from './components/Assignment/ViewAssignmentSection';
import ViewSubmission from './components/submissions/ViewSubmission';
import { Course, UserRole } from './types/lms.types';

interface LearningManagementSystemProps {
  isTemp?: boolean;
  onClose: () => void;
}

const LearningManagementSystem: React.FC<LearningManagementSystemProps> = ({ isTemp, onClose }) => {
  const [currentView, setCurrentView] = useState<'dashboard' | 'course' | 'assignmentView' | 'submissionView'>('dashboard');
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);
  const [currentRole, setCurrentRole] = useState<UserRole>('student');
  const [selectedAssignment, setSelectedAssignment] = useState<any | null>(null);

  // Mock user data - replace with actual context when available
  const mockUserData = {
    name: 'Basith',
    role: currentRole
  };

  const mockCollegeData = {
    name: 'Necttos College'
  };

  const handleCourseSelect = (course: any) => {
    setSelectedCourse(course);
    setCurrentView('course');
  };

const handleViewAssignment = (assessment: any) => {
  console.log(assessment);
  if (assessment.status === 'Submitted' || assessment.status === 'Graded') {
    setSelectedAssignment(assessment);
    setCurrentView('submissionView'); // for viewing submission/grade
  } else {
    setSelectedAssignment(assessment);
    setCurrentView('assignmentView'); // for submitting
  }
};



  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedCourse(null);
  };

  const handleRoleSwitch = (role: UserRole) => {
    setCurrentRole(role);
    handleBackToDashboard(); // Reset to dashboard when switching roles
  };

  return (
    <Main width="100%" height="100%" title="Learning Management System">
      <Header>
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-green-600 to-blue-600 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.34 6.234L12 20.5l-6.5-3.688a12.083 12.083 0 01.34-6.234L12 14z" />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-900 dark:text-white">
                Learning Management System
              </h1>
              <p className="text-xs text-slate-500 dark:text-slate-400">Manage Courses & Students</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            {/* Role Switch Panel */}
            <div className="flex items-center space-x-2 bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
              <span className="text-xs text-gray-600 dark:text-gray-400 px-2">Demo Role:</span>
              {(['student', 'teacher', 'admin'] as UserRole[]).map((role) => (
                <button
                  key={role}
                  onClick={() => handleRoleSwitch(role)}
                  className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
                    currentRole === role
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
                  }`}
                >
                  {role.charAt(0).toUpperCase() + role.slice(1)}
                </button>
              ))}
            </div>
          
            
            <Button type="close" onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </Header>

      <div className="min-h-[80vh] bg-gradient-to-br from-green-50 via-white to-blue-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 overflow-auto">
        {currentView === 'dashboard' && (
  <LMSDashboard
    userRole={currentRole}
    userName={mockUserData?.name || 'User'}
    collegeData={mockCollegeData}
    onCourseSelect={handleCourseSelect}
  />
)}

{currentView === 'course' && selectedCourse && (
  <CourseView
    course={selectedCourse}
    userRole={currentRole}
    onBack={handleBackToDashboard}
    onViewAssignment={handleViewAssignment}
  />
)}

{currentView === 'assignmentView' && selectedAssignment && (
  <ViewAssignmentSection
    assignment={selectedAssignment}
    onBack={() => setCurrentView('course')}
  />
)}
{currentView === 'submissionView' && selectedAssignment && (
  <ViewSubmission
    submission={selectedAssignment} // You can rename `assignment` to `submission` for clarity
    onBack={() => setCurrentView('course')}
  />
)}


      </div>
    </Main>
  );
};

export default LearningManagementSystem;
